"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputSelectReadOnly = exports.inputSelect = void 0;

var _stylitas = require("@creditas/stylitas");

const inputSelect = ({
  as
}) => as === 'select' && (0, _stylitas.css)`
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
  `;

exports.inputSelect = inputSelect;

const inputSelectReadOnly = ({
  readOnly
}) => readOnly && (0, _stylitas.css)`
    pointer-events: none;
  `;

exports.inputSelectReadOnly = inputSelectReadOnly;